import { createAsyncThunk } from '@reduxjs/toolkit';
import { ItemsType } from '@app/common/list/listSlice';
import {
  healthCheckConfirmedUrl,
  healthCheckDoneUrl,
  healthCheckOrderedUrl,
  healthCheckPendingUrl,
} from '@app/definition/API';
import apiClient from '@app/network/apiClient';
import { OrderFilters } from '../ordersTable/types';

type OrderTypeOptions = {
  [key: string]: string;
};

const healthCheckUrl: OrderTypeOptions = {
  ordered: healthCheckOrderedUrl,
  confirmed: healthCheckConfirmedUrl,
  pending: healthCheckPendingUrl,
  done: healthCheckDoneUrl,
};

export const fetchOrdersData = async (
  filters: OrderFilters
): Promise<{ data: ItemsType; total: number }> => {
  const params = {
    page: filters.page,
    limit: filters.limit,
    sortBy: filters.column || undefined,
    sortDir: filters.column ? filters.order : undefined,
    search: filters.searchText || undefined,
    date: filters.startDate || undefined,
    type: filters.type || undefined,
    category: filters.category || undefined,
  };
  const { ordersState } = filters;
  const url = healthCheckUrl[ordersState as string];
  const response = await apiClient(url, { params });

  if (response.status >= 400) {
    throw new Error(response.data.message || 'Invalid response!');
  }

  return response.data;
};

const fetchOrders = createAsyncThunk(
  'orders/fetchOrders',
  async (filters: OrderFilters) => {
    const ordersData = await fetchOrdersData(filters);

    return {
      data: ordersData?.data || [],
      total: ordersData?.total || 0,
    };
  }
);

export default fetchOrders;
